﻿import Club from "@/orm/models/Club"
import { Model } from 'pinia-orm'
import { DateCast } from "pinia-orm/casts"
import { Attr, BelongsTo, Bool, Cast, Num, Str } from 'pinia-orm/decorators'

export default class Member extends Model {
    static entity = 'members'

    @Str( '', { notNullable: true } ) declare id: string
    @Str( '', { notNullable: true } ) declare firstName: string
    @Str( '', { notNullable: true } ) declare lastName: string
    @Cast( () => DateCast ) @Attr( null ) declare birthDate: string | null
    @Str( null ) declare regId: string | null
    @Str( null ) declare sex: string | null
    @Str( null ) declare phone: string | null
    @Str( null ) declare email: string | null
    @Num( null ) declare clubId: number | null
    @BelongsTo( () => Club, 'clubId' ) declare club: Club
    @Bool( false, { notNullable: true } ) declare isLicensed: boolean

    get fullName (): string {
        return ( this.firstName + " " + this.lastName ).trim()
    }

    get reverseFullName (): string {
        return ( this.lastName + " " + this.firstName ).trim()
    }

    get reverseShortName (): string {
        return this.lastName + " " + this.firstName.toShortPersonalName()
    }

    get reverseFullNameWithBirthYear (): string {
        return this.reverseFullName + " (" + this.birthYear + ")"
    }

    get reverseFullNameWithBirthYearWithRegId (): string {
        return this.regId + " " + this.reverseFullNameWithBirthYear
    }

    get reverseFullNameWithRegId (): string {
        return this.regId + " " + this.reverseFullName
    }

    get reverseShortNameWithRegId (): string {
        return this.regId + " " + this.reverseShortName
    }

    get birthYear (): number | null {
        if ( this.birthDate === null || this.birthDate === undefined )
            return null

        const birthDate = new Date( this.birthDate )

        return birthDate.getFullYear()
    }

    static piniaOptions = {
        persist: true
    }
}
